import axios from "axios";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

const client = axios.create({ baseURL: BASE });

export const sendContact = async (payload) => {
  const { data } = await client.post("/contact", payload);
  return data;
};

export const createBooking = async (payload) => {
  const { data } = await client.post("/bookings", payload);
  return data;
};

export const createCheckout = async (payload) => {
  const { data } = await client.post("/payments/checkout", payload);
  return data;
};

export const getPaymentStatus = async (sessionId) => {
  const { data } = await client.get(`/payments/status/${sessionId}`);
  return data;
};

export default client;
